import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import mov from '../ui/icons/MOV.svg';
import mp4 from '../ui/icons/MP4.svg';
import wmv from '../ui/icons/WMV.svg';
import avi from '../ui/icons/AVI.svg';
import pdf from '../ui/icons/pdf_new.svg';
import jpg from '../ui/icons/jpg_new.svg';
import png from '../ui/icons/png_new.svg';
import gif from '../ui/icons/icon_gif.png';
import { version } from '../util/animation';
import { canUserNotPermission, canSwitchVersion } from '../authorizations';
import apiClient from '../util/api-client';

export default class ModalDownloadAnimation extends Component {
  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  constructor(props) {
    super(props);
    const { currentPageId, currentAnimationId, animations, pages, baseURL } = props;
    const animation = this.selectedAnimation(animations, currentAnimationId)
    this.state = {
      selectPageId: currentPageId,
      selectVersion: currentAnimationId,
      animationsRender: animations,
      pagesRender: pages,
      disabledChangeVersion: false,
      is_not_video: animation && animation.category !== 'video',
      selectedAnimation: animation,
    };
    this.apiClient = apiClient({ baseURL: baseURL });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.pages !== this.props.pages || nextProps.animations !== this.props.animations) {
      this.setState({ pagesRender: nextProps.pages, animationsRender: nextProps.animations })
    }
    if (nextProps.currentPageId !== this.props.currentPageId) {
      this.setState({ selectPageId: nextProps.currentPageId });
    }
    if (nextProps.currentAnimationId !== this.props.currentAnimationId) {
      this.setState({
        selectVersion: nextProps.currentAnimationId,
        is_not_video: nextProps.animations.find((animation) => animation.id === Number(nextProps.currentAnimationId))?.category !== 'video',
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentPageId !== this.props.currentPageId) {
      this.setState({ selectPageId: this.props.currentPageId });
    }
    if (prevProps.currentAnimationId !== this.props.currentAnimationId) {
      this.setState({
        selectVersion: this.props.currentAnimationId,
        selectedAnimation: this.props.animations.find((animation) => animation.id === Number(this.props.currentAnimationId)),
      });
    }
  }
  
  changeTypeDownLoad = (event, type) => {
    const {changeTypeDownLoad} = this.props;
    changeTypeDownLoad(event, type);
  }

  onChangePage = async (event) => {
    const newPageId = event.target.value
    const { fetchListAnimationsDownload } = this.props;
    this.setState({ selectPageId: newPageId });
    const newAnimations = await this.apiClient.get(`pages/${newPageId}/animations`);
    const lastAnimations = newAnimations.data[newAnimations.data.length - 1]
    this.setState({ animationsRender: newAnimations.data, selectVersion: lastAnimations.id });
    await fetchListAnimationsDownload(newPageId)
    const animation = this.selectedAnimation(newAnimations.data, lastAnimations.id)
    this.setState({ selectedAnimation: animation })
    this.setState({ is_not_video: animation.category !== 'video' })
    this.props.changeTypeDownLoad(event, '');
  }

  onChangeVersion = (event) => {
    const {animationsRender} = this.state;
    const newAnimation = this.fetchNewAnimation(event.target.value)
    if (newAnimation?.is_video_embed) {
      Popup.alert('YouTubeデータはダウンロードできません。')
      return
    }
    this.setState({ is_not_video: !!newAnimation && newAnimation.category !== 'video' })
    const versionId = event.target.value
    this.setState({ selectVersion: versionId, selectedAnimation: newAnimation });
    this.props.changeTypeDownLoad(event, '');
  }

  downloadVideo = () => {
    const { downloadVideo } = this.props;
    const selectDownloadAnimationId = this.state.selectVersion || this.props.currentAnimationId
    const newAnimation = this.fetchNewAnimation(selectDownloadAnimationId)
    if (newAnimation?.is_video_embed) {
      Popup.alert('YouTubeデータはダウンロードできません。')
      return
    }
    downloadVideo(selectDownloadAnimationId)
  }

  downloadImage = () => {
    if (this.state.selectedAnimation?.need_conversion) {
      Popup.alert(`現在、データをアップロード中です。<br>アップロードが完了したら、ダウンロードが可能になります。`)
      return;
    }

    const { downloadImage } = this.props;
    const selectDownloadAnimationId = this.state.selectVersion || this.props.currentAnimationId
    downloadImage(selectDownloadAnimationId)
  }

  downloadAnimation = () => {
    const isNotVideo = this.state.is_not_video
    if (isNotVideo) {
      this.downloadImage()
    } else {
      this.downloadVideo()
    }
  }

  fetchNewAnimation = (animationId) => {
    const { animationsRender } = this.state;
    return animationsRender.find((animation) => animation.id === Number(animationId))
  }

  selectedAnimation = (animations, currentVersionId) => {
    return animations.filter(item => item.id === parseInt(currentVersionId))[0]
  }

  isGifAnimation = () => {
    const { selectedAnimation } = this.state;
    if (!selectedAnimation?.file_object || !selectedAnimation?.file_object?.url) {
      return false;
    }

    return selectedAnimation.file_object.url.split('.').pop().trim().toLowerCase() === 'gif'
  }


  render() {
    const { isOpen, selectTypeDownload, role } = this.props;
    const { selectPageId, selectVersion, pagesRender, animationsRender, selectedAnimation} = this.state;
    const newAnimation = this.fetchNewAnimation(selectVersion)
    const versionDownload = newAnimation?.is_video_embed ? null : selectVersion
    const isDownloadOnlyPdf = selectedAnimation?.is_pdf || selectedAnimation?.is_download_only_pdf

    return (
      <Modal isOpen={isOpen} className="animation-uploader-modal modal-dialog-centered modal-download-animation modal-style" size="md">
        <ModalBody>
          <div className='justify-content-center text-center'>
            <span className='font-weight-bold text-black title-modal'>Downloadする形式を選択してください。</span><br/>
          </div>
          <div className='justify-content-center text-center d-flex'>
            <div className='w-30 show-select-akaire-page-and-version'>
              {pagesRender &&
                <Input type="select" id="select-current-page-animation"
                      onChange={(event) =>this.onChangePage(event)} value={selectPageId} disabled={canUserNotPermission(role)}>
                  {
                    pagesRender.map((page, i) => {
                      return (
                        <option value={page.id} key={i}>
                          {page.title}
                        </option>
                      );
                    })
                  }
                </Input>
              }
              {animationsRender &&
                <Input type="select" id="animation-selector-comemnt" className="text-right w-30" value={versionDownload || null}
                      onChange={(event) => this.onChangeVersion(event)} disabled={!canSwitchVersion(role, animationsRender)}>
                  {
                    animationsRender.map((animation, i) => {
                      return (
                        <option value={animation.id} data-is_video_embed={animation.is_video_embed} key={i}>
                          {version(animation)}
                        </option>
                      );
                    })
                  }
                </Input>
              }
            </div>
          </div>
          { this.state.is_not_video ?
            (
              <div className='d-flex mb-2 mt-2 align-items-center justify-content-center'>
                <div className='bg-wild-sand d-block pd-10px mr-3 list-downloads-type'>
                  {this.isGifAnimation() &&
                    <div className='d-flex cursor-pointer' onClick={(event) => this.changeTypeDownLoad(event, 'GIF')}>
                      <img className="img" width={20} height={25} src={gif} alt="gif" />
                      <span className='font-size-20px font-weight-bold ml-2'>GIF</span>
                    </div>
                  }
                  {isDownloadOnlyPdf &&
                    <div className='d-flex cursor-pointer' onClick={(event) => this.changeTypeDownLoad(event, 'PDF')}>
                      <img className="img" width={20} height={25} src={pdf} alt="pdf" />
                      <span className='font-size-20px font-weight-bold ml-2'>PDF</span>
                    </div>
                  }
                  { !isDownloadOnlyPdf &&
                    <div className='d-flex cursor-pointer' onClick={(event) => this.changeTypeDownLoad(event, 'PNG')}>
                      <img className="png" width={20} height={25} src={png} alt="png" />
                      <span className='font-size-20px font-weight-bold ml-2'>PNG</span>
                    </div>
                  }
                  { !isDownloadOnlyPdf &&
                    <div className='d-flex cursor-pointer' onClick={(event) => this.changeTypeDownLoad(event, 'JPG')}>
                      <img className="jpg" width={20} height={25} src={jpg} alt="jpg" />
                      <span className='font-size-20px font-weight-bold ml-2'>JPG</span>
                    </div>
                  }
                </div>
                {
                  selectTypeDownload === '' ? (
                    <span className="ml-5 font-size-16px text-black">形式を選択</span>
                  ) : (
                    <span className="ml-5 font-size-16px text-red font-weight-bold">{selectTypeDownload}形式</span>
                  )
                }
              </div>
            ) :
            (<div className='d-flex mb-2 mt-2 align-items-center justify-content-center'>
              <div className='bg-wild-sand d-block pd-10px mr-3 list-downloads-type'>
                <div className='d-flex cursor-pointer' onClick={(event) => this.changeTypeDownLoad(event, 'mp4')}>
                  <img className="img" width={28} height={28} src={mp4} alt="mp4" />
                  <span className='font-size-20px font-weight-bold ml-2'>MP4</span>
                </div>
                <div className='d-flex cursor-pointer' onClick={(event) => this.changeTypeDownLoad(event, 'mov')}>
                  <img className="jpg" width={28} height={28} src={mov} alt="mov" />
                  <span className='font-size-20px font-weight-bold ml-2'>MOV</span>
                </div>
                <div className='d-flex cursor-pointer' onClick={(event) => this.changeTypeDownLoad(event, 'wmv')}>
                  <img className="png" width={28} height={28} src={wmv} alt="wmv" />
                  <span className='font-size-20px font-weight-bold ml-2'>WMV</span>
                </div>
                <div className='d-flex cursor-pointer' onClick={(event) => this.changeTypeDownLoad(event, 'avi')}>
                  <img className="png" width={28} height={28} src={avi} alt="avi" />
                  <span className='font-size-20px font-weight-bold ml-2'>AVI</span>
                </div>
              </div>
              {
                selectTypeDownload === '' ? (
                  <span className="ml-5 font-size-16px text-black font-weight-bold">形式を選択</span>
                ) : (
                  <span className="ml-5 font-size-16px text-red font-weight-bold">
                    {selectTypeDownload.toUpperCase()}形式
                  </span>
                )
              }
            </div>)
          }
          <div className="justify-content-center text-center mt-2">
            <Button type="button" color="primary" disabled={selectTypeDownload === ''} onClick={this.downloadAnimation}
                    className="text-white">ダウンロードする</Button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
};
